<template>
  <div class="g-container g-container-bg">
    <!--详情头部-->
    <div class="com-detail-hd">
      <div class="com-hd-inner"
           :style="{ backgroundImage: `url(${backgroundImage})` }">
        <div class="com-hd-info">
          <div class="com-hd-face">
            <img :src="header.picPath"
                 alt />
          </div>
          <div class="com-hd-name detail-p">
            <div class="hd-bottom-td">
              <div class="hd-name-row hd-name-title">{{ header.title }}</div>
              <!--今日信息-->
              <div class="hd-name-row">
                <span>今天</span>
                <span>{{ header.now.slice(0, 10) }}</span>
                <span>{{ header.dayOfWeek }}</span>
                <span>天气：{{ weather }}</span>
                <div class="proj-status-p"
                     :class="stateClass"
                     @click="showProj">
                  <span>项目状态：</span>
                  <span class="disc-p"></span>
                  <span>{{ stateText }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--右侧操作-->
        <div class="com-hd-handle">
          <div class="hd-bottom-pro"
               @click="cooperationDir = !cooperationDir"
               v-if="canHanler && (this.header.forumStatus == 3 || this.header.forumStatus == 1)">
            <span>我的协作</span>
          </div>
          <div class="hd-bottom-td">
            <img src="../../../../html/pages/originality/visaFlowIndex/images/sign.png"
                 alt />
            <span class="cm-sign-btn"
                  @click="openQiandao">签到详情</span>
          </div>
        </div>
      </div>
    </div>
    <div class="m-container m-width">
      <!--面包屑-->
      <div class="crumbs-box">
        <router-link tag="a"
                     class="c-crumbs"
                     :to="{ name: 'default' }">首页</router-link>
        <span class="c-sep">&gt;</span>
        <span>匠心记</span>
        <span class="c-sep">&gt;</span>
        <span class="c-current">{{ header.title }}</span>
      </div>
      <!--主体-->
      <div class="origin-content">
        <div class="m-second-tabs">
          <span>我要看</span>
          <span :class="{ 'active': type == 'all' }"
                @click="changType('all')">全部</span>
          <!-- <span class="u-line">|</span> -->
          <span :class="{ 'active': type == 'daily' }"
                @click="changType('daily')">日报</span>
          <!-- <span class="u-line">|</span> -->
          <span :class="{ 'active': type == 'report' }"
                @click="changType('report')">周报</span>
          <!-- <span class="u-line">|</span> -->
          <span :class="{ 'active': type == 'qe' }"
                @click="changType('qe')">检查报告</span>
          <span :class="{ 'active': keshow == true }"
                @click="kejian">课件</span>
        </div>
        <div class="m-structure-content">
          <div class="m-structure-information"
               :style="{ padding: (keshow == true ? '0 19px' : '0 30px') }">
            <div class="m-prise-content">
              <div class="e-prise-box"
                   @click="goto(item)"
                   v-for="(item, index) in list"
                   :key="index"
                   v-if="keshow == false">
                <!-- <router-link class="e-prise-box"
                                         tag="div"
                                         :to="{name:'jxjPostDetail',params:{id:item.id},query:{xid:xid}}"
                >-->
                <div class="prise-hd jxjDetail">
                  <div class="prise-face f-circle">
                    <div class="prise-img">
                      <img :src="item.postUser.headImage" />
                    </div>
                    <div class="prise-time">{{ item.postUser.nickName }}</div>
                  </div>
                  <div class="prise-hd-info jxjDetail">
                    <div class="prise-hd-name">
                      <span>{{ item.title }}</span>
                      <span class="prise-tag-icon">{{ item.type }}</span>
                    </div>
                    <div class="prise-status">
                      <span class="prise-status-txt">发布时间：{{ getDate(item.createdTime) }}</span>
                      <span class="prise-status-txt">{{ item.weather }}</span>
                    </div>
                    <div class="prise-art-txt">{{ item.content }}</div>
                    <!-- <div class="prise-time">{{item.postUser.type}}：{{item.postUser.nickName}}</div> -->
                  </div>
                  <!-- <div class="prise-status">
                    <span class="prise-status-txt">安全状况：{{item.safeState}}</span>
                    <span class="prise-status-txt">{{item.weather}}</span>
                  </div>-->
                </div>

                <div class="prise-article jxjDetail">
                  <!--<div class="prise-art-name">-->
                  <!--<b>嘉兴世合小镇</b>-->
                  <!--<span class="art-tips">推广</span>-->
                  <!--</div>-->
                  <div class="cp-column hover-scale pic-230-180"
                       v-if="item.images.length > 0">
                    <div class="cp-item"
                         v-for="(img, i) in item.images"
                         :key="i">
                      <img :src="img"
                           alt />
                    </div>
                  </div>
                  <div class="u-news-handle">
                    <div class="un-left">
                      <span class="un-col">
                        <i class="n-small-icon comment-icon"></i>
                        {{ item.repNum }}
                        <em class="c-arrow-up"></em>
                      </span>
                      <span class="un-col">
                        <i class="n-small-icon eye-icon"></i>
                        {{ item.hits }}
                      </span>
                    </div>
                  </div>
                  <div class="comment-box"
                       v-if="item.reps.length > 0">
                    <div class="prise-comment">
                      <div class="comment-list">
                        <ul>
                          <li v-if="!rep.isChild"
                              v-for="(rep, r) in item.reps"
                              :key="r">
                            <div class="comment-face">
                              <img :src="rep.headImage"
                                   alt />
                            </div>
                            <div class="comment-info">
                              <div class="comment-name">{{ rep.nickName }}</div>
                              <div class="comment-msg">{{ rep.content }}</div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="keshow == true"
                   class="videoclass">
                <div class="case-list">
                  <div class="videoList"
                       v-for="(item, index) in courseware"
                       :key="index">
                    <div style="position: relative;background: #F7F7F7;">
                      <i class="bofang_video"
                         @click="videos(index)"
                         :id="'play_' + index"
                         :data-playId="item.Id"></i>
                      <img class="tup"
                           :src="item.VideoBgUrl"
                           :id="'Bgimg_' + index">
                      <video :src="item.VideoUrl"
                             :data-src="item.VideoUrl"
                             preload="preload"
                             controls="controls"
                             width="100%"
                             class="myVideo"
                             :data-playId="item.Id"
                             :data-index="index"></video>
                      <div class="title">{{ item.Title }}</div>
                      <div class="explain">
                        <div class="duration"><span class="VideoTime"></span><span class="maleft19">{{ item.VideoTime
                        }}</span></div>
                        <div class="sum"><span class="PlayCount"></span><span>{{ item.PlayCount }}</span></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="m-pages">
              <button type="button" disabled="disabled" class="btn-prev">上一页</button>
              <dl class="u-pager">
                <dd class="active">1</dd>
                <dd>2</dd>
                <dd>3</dd>
                <dd class="dots">···</dd>
                <dd>8</dd>
              </dl>
              <button type="button" class="btn-next">下一页</button>
            </div>-->

            <button v-if="count > list.length"
                    @click="more"
                    type="button"
                    class="prompt-txt">加载更多</button>
          </div>
          <div class="m-structure-quick">
            <div class="structure-btn"
                 @click="showPoP">
              <div>
                <img src="../../../../html/pages/originality/originality/images/publish.png"
                     alt />
                <span>发布内容</span>
              </div>
            </div>

            <div class="structure-box"
                 style="padding: 10px 15px;">
              <div class="signInDIv"><b class="signIn">每日签到</b></div>
              <div class="font">
                <span>签到： </span>
                <span v-if="timeDate"><img src="../../../../html/pages/originality/originality/images/time.png"
                       alt
                       class="location"
                       style="margin-top:4px;" />{{ signInTime }}</span>
                <span v-else
                      class="NOlocation">未签到</span>
              </div>
              <div class="font12"
                   v-if="timeDate">
                <div class="marbot">
                  <img src="../../../../html/pages/originality/originality/images/location.png"
                       alt
                       class="location" /><span class="sin_font">{{ signInAddr }}</span>
                </div>
                <span>距离目标{{ signInAway }}米</span>
              </div>
              <hr>
              <div class="font"
                   v-if="timeDate">
                <span>签退： </span>
                <span v-if="timeDate && signOutTime"><img src="../../../../html/pages/originality/originality/images/time.png"
                       alt
                       class="location"
                       style="margin-top:4px;" />{{ signOutTime }}</span>
                <span v-else
                      class="NOlocation">未签退</span>
              </div>
              <div class="font12"
                   v-if="timeDate && signOutTime">
                <div class="marbot"><img src="../../../../html/pages/originality/originality/images/location.png"
                       alt
                       class="location" />{{ signOutAddr }}</div>
                <span>距离目标{{ signOutAway }}米</span>
              </div>
            </div>

            <div class="structure-box pd-small">
              <div class="common-tit-h2">
                <b>项目概况简述</b>
              </div>
              <div class="project-intro">
                <!-- <div class="pro-intro-row">入场时间：{{header.creatTime.split(' ')[0]}}</div> -->
                <div class="pro-intro-row">项目地点：{{ header.proAddr }}</div>
                <div class="pro-intro-row">项目简介：</div>
                <div class="pro-intro-txt">{{ header.desc }}</div>
              </div>
              <div class="common-tit-h2">
                <a @click="openxq"
                   class="more-tit-btn">项目详情&gt;</a>
              </div>
            </div>

            <div class="report-btn-p"
                 @click="reportShow">检测报告/竣工验收单</div>

            <div class="structure-box">
              <div v-if="item.type == '项目经理'"
                   v-for="(item, index) in header.projectPartner"
                   :key="index">
                <div class="com-md-face">
                  <img :src="item.headImage"
                       alt />
                </div>
                <div class="str-row">
                  <span class="str-label">{{ item.type }}</span>
                  <i class="star-icon three-star"></i>
                </div>
                <div class="str-row">
                  <span class="str-name">{{ item.nickName }}</span>
                  <span class="str-tag-icon">{{ item.tags.join(',') }}</span>
                </div>
              </div>
            </div>
            <div class="structure-box"
                 v-if="header.lsProject && header.lsProject.length > 0">
              <div class="common-tit-h2">
                <b>类似项目</b>
              </div>
              <div class="guess-like">
                <router-link tag="a"
                             v-for="(item, i) in header.lsProject"
                             :key="i"
                             :to="{ name: 'jxjDetail', params: { id: item.id } }"
                             class="guess-item">
                  <div class="guess-face">
                    <img :src="item.picPath"
                         alt />
                  </div>
                  <div class="guess-info">{{ item.title }}</div>
                </router-link>
              </div>
            </div>
            <div class="scan-code-quick">
              <div class="code-quick-pic">
                <qrcode-vue :value="localHref"
                            :size="170"
                            level="H"></qrcode-vue>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--写报告 显示 +show-->
    <div class="shadow-fixed show"
         v-if="popDir">
      <div class="mask"></div>
      <div class="bomb-com-box bomb-reply">
        <div class="bomb-small-close"
             @click="showPoP"></div>
        <div class="bomb-entrance">
          <div class="b-entrance-btn"
               @click="gotoCreate('zt')">
            <img src="../../../../html/pages/originality/originality/images/zhuti.png"
                 alt />
            <p>写主题</p>
          </div>
          <div class="b-entrance-btn"
               @click="gotoCreate('zb')">
            <img src="../../../../html/pages/originality/originality/images/zhoubao.png"
                 alt />
            <p>写周报</p>
          </div>
          <div class="b-entrance-btn"
               @click="gotoCreate('qe')">
            <img src="../../../../html/pages/originality/originality/images/QEbao.png"
                 alt />
            <p>写QE报告</p>
          </div>
          <div class="b-entrance-btn"
               @click="gotoCreate('daliy')">
            <img src="../../../../html/pages/originality/originality/images/databao.png"
                 alt />
            <p>写日报</p>
          </div>
          <div class="b-entrance-btn"
               @click="gotokejian()">
            <img src="../../../../html/pages/originality/originality/images/kejian.png"
                 alt />
            <p>上传课件</p>
          </div>
        </div>
      </div>
    </div>
    <div class="shadow-fixed show"
         v-if="cooperationDir">
      <div class="mask"></div>
      <div class="bomb-com-box bomb-reply">
        <div class="bomb-small-close"
             @click="cooperationDir = !cooperationDir"></div>
        <div class="bomb-entrance">
          <div class="b-entrance-btn"
               @click="gotoVisaflow">
            <img src="../../../../html/pages/originality/originality/images/visa.png"
                 alt />
            <p>指令单流程</p>
          </div>
          <div class="b-entrance-btn"
               @click="gotoLogistics">
            <img src="../../../../html/pages/originality/originality/images/Logistics.png"
                 alt />
            <p>协作流</p>
          </div>
          <div class="b-entrance-btn">
            <img src="../../../../html/pages/originality/originality/images/process.png"
                 alt />
            <p>工序交接流</p>
          </div>
        </div>
      </div>
    </div>
    <d-qiandao v-if="qiandaoDir"
               @close="closeQiandao"></d-qiandao>
    <d-xiangqing :detail="header"
                 @initBaiduMap="initBaiduMap"
                 @close="closexq"
                 v-if="xiangqingDir"></d-xiangqing>

    <div class="proj-box-p"
         v-if="projIsShow">
      <div class="mask-p"></div>
      <div class="proj-content-p"
           :style="{ height: this.height }">
        <div class="close-p"
             @click="projIsShow = false"></div>
        <div class="content-head-p">
          <p>项目状态</p>
        </div>
        <div class="status-p">
          <div class="state-box-p">
            <div class="img-box-p">
              <img :src="stateImage1"
                   alt />
              <span>{{ stateText1 }}</span>
            </div>
            <div class="line-p"></div>
            <div class="img-box-p">
              <img :src="stateImage2"
                   alt />
              <span>{{ stateText2 }}</span>
            </div>
          </div>
          <div class="status-btn-p"
               @click="updateState">
            <p>{{ btnText }}</p>
          </div>
          <p v-if="this.header.forumStatus == 3"
             class="message-p">进入决算状态将不能上传检测报告</p>
        </div>
      </div>
    </div>

    <div class="report-box-p"
         v-show="reportIsShow">
      <div class="mask-p"></div>
      <div class="report-content-p">
        <div class="close-p"
             @click="closeReport"></div>
        <div class="report-inner-p">
          <div class="title-p">
            <p>竣工验收单</p>
            <p class="no-title-p"
               v-if="jointWarranty.length == 0">暂无竣工验收单</p>
          </div>
          <div class="warranty-img-p">
            <img :src="img.pic || img"
                 alt
                 v-for="img of jointWarranty"
                 :key="img.pic"
                 @click="goToReportImg" />
          </div>
          <div class="title-p">
            <p>检测报告</p>
            <p class="no-title-p"
               v-if="reportInfo.length == 0">暂无检测报告</p>
          </div>
          <div class="report-item-p">
            <!--- :style="{background:getColor()}" allColors[report.Id]-->
            <div @mouseenter="onMousteIn(index)"
                 @mouseleave="onMousteOut()"
                 v-for="(report, index) of reportInfo"
                 :key="report.Id"
                 :style="allColors[report.Id]"
                 @click="goToReportImg(report, index)"
                 style="position: relative;"
                 :class="'delete' + report.Id">
              <i class="fa-safari"
                 @click="del(report.Id, index, $event)"
                 v-show="seen && (index == current)"
                 v-if="canHanler"></i>
              <p>{{ report.DetName }}</p>
              <p>{{ report.DetId }}</p>
            </div>
          </div>
          <div class="jump-btn-p"
               v-if="canHanler">
            <p class="test"
               @click="goToReport"
               v-if="(this.header.forumStatus == 3 || this.header.forumStatus == 1)">
              上传检测报告</p>
            <p class="test"
               @click="goToWarranty"
               v-if="this.header.forumStatus == 3">上传验收单</p>
            <p class="test"
               @click="goToCheckList">上传项目资料清单</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '../../../../html/components/detailHd/detailHd.scss';
import '../../../../html/components/tabs/tabs.scss';
import '../../../../html/components/crumbs/crumbs.scss';

import '../../../../html/components/structure/structure.scss';
import '../../../../html/components/enterprise/enterprise.scss';
import '../../../../html/components/picture/picture.scss';
import '../../../../html/components/comments/comments.scss';
import '../../../../html/components/page/page.scss';
import '../../../../html/pages/originality/originality/originality.scss';
import '../../../../html/pages/originality/modifyProject/modifyProject.scss';

import { getJxjDetail, getJxjLog, getWeather, SetProjectLogStatus, GetProjectAuthority, GetProDetectionInfo, getCourseware, playNum, getJxjSignInfos } from '../../../../api/index.js';
import timeago from '../../../../pubilc/util/timeago';

import dQiandao from './components/d-qiandao.vue';
import dXiangqing from './components/d-xiangqing.vue';
import hQrcode from '../../../../components/h-qrcode/h-qrcode';

import QrcodeVue from 'qrcode.vue';

import { mapState } from "vuex";

export default {
  name: 'originality',
  components: {
    dQiandao,
    dXiangqing,
    hQrcode,
    QrcodeVue
  },
  data () {
    return {
      localHref: location.href,
      qiandaoDir: false,
      xiangqingDir: false,
      popDir: false,
      cooperationDir: false,
      header: { now: '', picPath: '' },
      list: [],
      weather: '',
      type: 'all',
      pageIndex: 0,
      count: 0,
      xid: this.$route.params.id,
      backgroundImage: '',
      sunnyImage: './gif/sunny.gif',
      hotImage: './gif/hot.gif',
      rainImage: './gif/rain.gif',
      snowImage: './gif/snow.gif',
      cloudyImage: './gif/cloudy.gif',
      fogImage: './gif/fog.gif',
      projIsShow: false,
      stateClass: "",
      stateText: "",
      canHanler: false,
      reportIsShow: false,
      jointWarranty: [],
      reportInfo: [],
      stateText1: "",
      stateText2: "",
      btnText: "",
      stateImage1: "",
      stateImage2: "",
      height: "",
      allColors: {},
      seen: false,
      current: 0,
      keshow: false,
      courseware: [],
      uesrRole: false,
      signInAddr: '',   //签到地址
      signInAway: '',   //签到地址距离目的地距离
      signInTime: '',    // 签到时间
      signOutAddr: '',   //签退地址距离目的地距离
      signOutTime: '',   //签退时间
      signOutAway: '',   //签退地址距离目的地距离
      timeDate: false,
      isAdmin: false,
      proUserType: 0

    };
  },
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    gotoVisaflow () {
      this.$router.push(`/originality/visaflowIndex/${this.$route.params.id}/1`)
    },
    videos (index) {
      let myVideoList = document.getElementsByClassName('myVideo');
      myVideoList[index].play();
      let play_id = document.getElementById('play_' + index);
      play_id.style.display = "none";
      let Bgimg_id = document.getElementById('Bgimg_' + index);
      Bgimg_id.style.display = "none"
      let data = {
        id: myVideoList[index].getAttribute('data-playId'),
      }
      let res = playNum(data);
      this.addPlayNum(index)
    },
    // 增加播放量
    addPlayNum (index) {
      let that = this;
      let myVideoList = document.getElementsByClassName('myVideo');
      for (let val of myVideoList) {
        let data = {
          id: val.getAttribute('data-playId'),
        }
        val.addEventListener('play', function () {
        })
        val.addEventListener('ended', function () {
          let play_id = document.getElementById('play_' + index);
          play_id.style.display = "block";
          let Bgimg_id = document.getElementById('Bgimg_' + index);
          Bgimg_id.style.display = "block"

        })
      }

    },
    gotoLogistics () {
      this.$router.push(`/originality/logisticsIndex/${this.$route.params.id}/1/1`)
    },
    async kejian () {
      this.keshow = true
      this.count = 0
      this.type = '';
      let res = await getCourseware({
        forumId: this.$route.params.id
      });
      if (res.Type == 'Success') {
        let list = res.Data.list;
        for (let val of list) {
          if (val.VideoUrl.indexOf('https') == -1) {
            val.VideoUrl = 'https://www.iduilv.com' + val.VideoUrl;
          }

        }
        this.courseware = list
      }
    },
    async gotokejian () {
      if (this.isAdmin || this.proUserType == 1) {
        let routeData = this.$router.resolve({ name: 'caseCourse', params: { id: this.$route.params.id } });
        window.open(routeData.href, '_blank');
      } else {
        this.$message({ message: '警告，您目前没有上传权限', type: 'warning' });
      }
    },
    initBaiduMap () {
      let opints = this.header.proPoint.split(',');
      let that = this;
      let script = document.createElement("script");
      script.src = "//api.map.baidu.com/api?v=2.0&ak=uVdH4iqsEd2BPnlCupOlHFUytU7eqiWL&callback=createMap"
      document.head.appendChild(script)
      window.createMap = () => {
        //创建Map实例
        var map = new BMap.Map("mapContent");
        var point = new BMap.Point(opints[0], opints[1]);
        map.centerAndZoom(point, 16);
        var marker = new BMap.Marker(point);        // 创建标注    
        map.addOverlay(marker);
        map.enableScrollWheelZoom();
      }
    },
    async getHeader () {
      let res = await getJxjDetail({
        id: this.$route.params.id
      });
      if (res.Type == 'Success') {
        // res.Data.timeAgo = timeago(new Date(res.Data.now));
        this.header = res.Data;
        if (res.Data.jointWarranty != null) {
          if (res.Data.jointWarranty[0] === "[") {
            this.jointWarranty = JSON.parse(res.Data.jointWarranty)
          } else {
            this.jointWarranty = res.Data.jointWarranty.split(",")
          }
        }
        switch (this.header.forumStatus) {
          case 1:
            this.stateClass = "state1"
            this.stateText = "施工中"
            this.stateText1 = "施工中"
            this.stateText2 = "施工状态"
            this.btnText = "完成施工，进行下一步"
            this.stateImage1 = require("../../../../html/pages/originality/detail/images/state1.png")
            this.stateImage2 = require("../../../../html/pages/originality/detail/images/state2.png")
            break
          case 2:
            this.stateClass = "state2"
            this.stateText = "已结案"
            break
          case 3:
            this.stateClass = "state3"
            this.stateText = "竣工中"
            this.stateText1 = "竣工状态"
            this.stateText2 = "决算状态"
            this.btnText = "结束竣工，进行下一步"
            this.stateImage1 = require("../../../../html/pages/originality/detail/images/state3.png")
            this.stateImage2 = require("../../../../html/pages/originality/detail/images/state4.png")
            this.height = "330px"
            break
          case 4:
            this.stateClass = "state4"
            this.stateText = "决算中"
            break
        }
        this.getProjectAuthority()
      }
    },
    //获取列表数据
    async getJxjLog () {
      let res = await getJxjLog({
        id: this.$route.params.id,
        type: this.type,
        index: this.pageIndex,
        size: 10
      });
      if (res.Type == 'Success') {
        this.list = this.list.concat(res.Data.data);
        this.count = res.Data.count;
      }
    },
    async getWeather () {
      let res = await getWeather({
        city: '苏州'
      });
      if (res.Type == 'Success') {
        this.weather = res.Data;
        switch (this.weather) {
          case "晴":
            this.backgroundImage = this.sunnyImage;
            break;
          case "高温":
            this.backgroundImage = this.hotImage;
            break;
          case "雨":
            this.backgroundImage = this.rainImage;
            break;
          case "雪":
            this.backgroundImage = this.snowImage;
            break;
          case "雾":
            this.backgroundImage = this.fogImage;
            break;
          case "阴":
            this.backgroundImage = this.cloudyImage;
            break;
        }
      }
    },
    //加载更多
    more () {
      if (this.count > this.list.length) {
        this.pageIndex++;
        this.getJxjLog();
      }
    },
    changType (type) {
      this.pageIndex = 0;
      this.count = 0;
      this.list = [];
      this.type = type;
      this.keshow = false;
      this.getJxjLog();
    },
    goto (item) {
      // if (item.type != 'QE') {
      // window.open()
      // if (item.type == "QE") {
      if (item.type == "图文" || item.type == "普通") {
        let routeData = this.$router.resolve({ name: 'jxjPostDetail', params: { id: item.id } });
        window.open(routeData.href, '_blank');
      } else {
        let routeData = this.$router.resolve({ name: 'jxjPostDetails', params: { id: item.id } });
        window.open(routeData.href, '_blank');
      }
      // } else {
      //   let routeData = this.$router.resolve({ name: 'jxjPostDetail', params: { id: item.id } });
      //   window.open(routeData.href, '_blank');
      // }
      // this.$router.push();
      // }
    },
    gotoCreate (type) {
      if (type == 'qe') {
        this.$router.push({ name: 'createQEReport', params: { id: this.$route.params.id }, query: { type: 'QE' } })
      } else if (type == 'zb') {
        this.$router.push({ name: 'createReport', params: { id: this.$route.params.id }, query: { type: 'ZB' } })
      } else if (type == 'daliy') {
        this.$router.push({ name: 'createDaliy', params: { id: this.$route.params.id }, query: { title: this.header.title } })
      } else if (type == 'zt') {
        this.$router.push({ name: 'createQE', params: { id: this.$route.params.id }, query: { type: 'ZT' } });
      }
    },
    closeQiandao () {
      this.qiandaoDir = false;
    },
    openQiandao () {
      this.qiandaoDir = true;
    },
    closexq () {
      this.xiangqingDir = false;
    },
    openxq () {
      this.xiangqingDir = true;
    },
    showPoP () {
      this.popDir = !this.popDir;
    },
    showProj () {
      if (this.canHanler && (this.header.forumStatus == 1 || this.header.forumStatus == 3)) {
        this.projIsShow = true;
      }
    },
    async updateState () {
      let status;
      if (this.header.forumStatus == 1) {
        status = 3
      } else if (this.header.forumStatus == 3) {
        status = 4
      }
      let res = await SetProjectLogStatus({
        id: this.$route.params.id,
        status
      })
      if (res.Type == "Success") {
        this.$layer.msg(res.Content, (msg) => {
          this.$layer.close(msg)
          this.$router.go(0)
        })
      } else {
        this.$layer.alert(res.Content)
      }
    },
    async getProjectAuthority () {
      if (this.userInfo) {
        let res = await GetProjectAuthority({
          id: this.$route.params.id,
          userId: this.userInfo.id
        })
        if (res.Type == "Success") {
          this.isAdmin = res.Data.isAdmin
          this.proUserType = res.Data.proUserType
          if (res.Data.isAdmin || res.Data.isProAdmin || res.Data.proUserType != 0) {
            this.canHanler = true
          }

        }
      }
    },
    goToReport () {
      this.$router.push(`/originality/createTestReport/${this.$route.params.id}?type=report`)
    },
    goToWarranty () {
      this.$router.push(`/originality/createTestReport/${this.$route.params.id}?type=warranty`)
    },
    goToCheckList () {
      const checklistUrl = `/spc/checklist?projectId=${this.$route.params.id}`;
      window.open(checklistUrl, "_blank")
    },
    // 背景颜色
    // getColor() {
    //   let r = Math.floor(Math.random() * 256)
    //   let g = Math.floor(Math.random() * 256)
    //   let b = Math.floor(Math.random() * 256)
    //   while (r > 200 && g > 200 && b > 200) {
    //     r = Math.floor(Math.random() * 256)
    //     g = Math.floor(Math.random() * 256)
    //     b = Math.floor(Math.random() * 256)
    //   }
    //   return `rgb(${r},${g},${b})`
    // },
    getDate (date) {
      let newDate = new Date(date)
      let y = newDate.getFullYear()
      let m = newDate.getMonth() + 1
      let d = newDate.getDate()
      return `${y}年${m}月${d}日`
    },
    async getProDetectionInfo () {
      let res = await GetProDetectionInfo({
        id: this.$route.params.id,
      })
      if (res.Type == "Success") {
        this.reportInfo = res.Data
        this.reportInfo.forEach(item => {
          if (item.ImgUrl[0] == "[") {
            item.ImgUrl = JSON.parse(item.ImgUrl)
          } else {
            item.ImgUrl = item.ImgUrl.split(",")
            item.ImgUrl.forEach((img, i, arr) => {
              arr[i] = { pic: img }
            })
          }
        })
      }
    },
    goToReportImg (report, index) {
      let data
      if (typeof index === "number") {
        data = JSON.stringify(report.ImgUrl)
        // var data = JSON.stringify(det.ImgUrl)
      } else {
        data = JSON.stringify(this.jointWarranty)

      }
      let routeData = this.$router.resolve({ name: "reportImg", query: { id: this.$route.params.id, current_id: report.Id } });
      window.open(routeData.href, '_blank');
    },
    onMousteIn (index) {
      this.seen = true; //鼠标移入显示
      this.current = index;
    },
    onMousteOut (index) {
      this.seen = false; //鼠标移出隐藏
      this.current = null;
    },
    // 背景颜色
    async randomRgb () {
      let res = await GetProDetectionInfo({
        id: this.$route.params.id,
      })
      this.reportInfo = res.Data
      this.reportInfo.forEach(ite => {
        let R = Math.floor(Math.random() * 255);
        let G = Math.floor(Math.random() * 255);
        let B = Math.floor(Math.random() * 255);
        this.allColors[ite.Id] = {
          background: 'rgb(' + R + ',' + G + ',' + B + ')'
        };
      });
    },
    del (id, index, e) {
      e.stopPropagation()
      this.$axios.post('/Api/ProjectLog/DeleteProDetInfo/' + id).then(resp => {
        let res = resp.data
        if (res.Type == 'Success') {//成功接收的返回的数据
          this.reportInfo.splice(index, 1)//删除当前的div
        }
      }).catch(err => { })
    },
    reportShow () {
      this.reportIsShow = true
    },
    closeReport () {
      this.reportIsShow = false
    },
    async getData () {
      let res = await getJxjSignInfos({
        id: this.$route.params.id
      });
      if (res.Type == 'Success') {
        var data = res.Data[0]
        this.signInTime = data.signInTime  // 签到时间
        if (new Date(this.signInTime).toDateString() === new Date().toDateString()) {
          this.timeDate = true;
          this.signInAddr = data.signInAddr //签到地址
          this.signInAway = data.signInAway //签到地址距离目的地距离
          this.signOutAddr = data.signOutAddr //签退地址距离目的地距离
          this.signOutTime = data.signOutTime //签退时间
          this.signOutAway = data.signOutAway //签退地址距离目的地距离
        } else {
          this.timeDate = false;
        }
      }
    },
  },
  created () {
    this.getWeather();
    this.getHeader();
    this.getJxjLog();
    this.getProDetectionInfo();
    this.randomRgb();
    // this.getProjectAuthority()
    this.getData()

  },
  watch: {
    $route (to, from) {
      this.list = [];
      this.type = 'all';
      this.pageIndex = 0;
      this.count = 0;
      this.jointWarranty = []
      this.canHanler = false
      this.getWeather();
      this.getHeader();
      this.getJxjLog();
      this.getData()
    }
  },
};
</script>

<style>
.m-structure-content .structure-box.pd-small {
  padding: 5px 10px;
}

.sin_font {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  width: 142px;
  margin-top: -20px;
  margin-left: 18px;
}

.marbot {
  margin-bottom: 4px;
}

hr {
  margin: 12px 0;
  border: 0.7px solid #dde0e2;
}

.NOlocation {
  color: #f10707;
  float: right;
}

#mapContents {
  margin-top: 15px;
}

.font12 {
  font-size: 13px;
  margin-top: 5px;
  margin-left: 45px;
  color: #666;
}

.location {
  width: 11px;
  height: 13px;
  margin-top: 2px;
  margin-right: 6px;
}

.signInDIv {
  margin-top: 5px;
}

.signIn {
  font-size: 16px;
  color: #333;
}

.font {
  font-size: 14px;
  color: #333;
  margin-top: 10px;
}

.fa-safari {
  background: url(data:image/png;base64,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)
    no-repeat center center/100% 100%;
  width: 20px;
  height: 20px;
  position: absolute;
  margin-left: 62px;
  margin-top: -17px;
}

.hide {
  display: none;
}

.case-common-title {
  line-height: 36px;
  padding-left: 8px;
}

.case-list {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}

.videoList {
  margin: 30px 15px 30px 0px;
  width: 160px;
  height: 226px;
  background: #f7f7f7;
}

.videoList .explain div {
  width: 100%;
  color: #999999;
}

.explain {
  display: flex;
  justify-content: space-around;
  width: 100%;
  align-items: center;
}

.explain img {
  vertical-align: unset;
}

video {
  width: 160px;
  height: 144px;
  object-fit: fill;
}

.title {
  font-size: 14px;
  line-height: 20px;
  color: #333;
  width: 140px;
  height: 43px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  padding: 0 10px;
  overflow: hidden;
}

.duration {
  height: auto;
  margin-top: 2px;
  margin-left: 15px;
}

.sum {
  height: auto;
  margin-top: 2px;
  text-align: right;
  margin-right: 15px;
}

.tup {
  width: 160px;
  height: 144px;
  position: absolute;
  z-index: 1;
}

.bofang_video {
  position: absolute;
  left: calc(50% - 24px);
  top: calc(50% - 64px);
  z-index: 2;
}

.videoclass {
}

.case-list {
  width: 100%;
  height: 100%;
}

.maleft19 {
  margin-left: 19px;
}

.videoList:nth-child(5n + 5) {
  margin-right: 0px;
}

.bomb-com-box.bomb-reply {
  width: 800px;
  height: 232px;
  border-radius: 10px;
}

.bomb-com-box.bomb-reply .bomb-entrance .b-entrance-btn p {
  font-size: 16px;
  color: #333;
}

.bomb-com-box.bomb-reply .bomb-entrance .b-entrance-btn {
  margin: 0 34px;
}

button.prompt-txt {
  margin: 80px auto 25px;
}

.explain {
  padding-bottom: 10px;
}
</style>
